// extracted by mini-css-extract-plugin
export default {"container":"AssignClassSettingsDataGridFooter__container___zBrFR","navigation":"AssignClassSettingsDataGridFooter__navigation___nPfgT"};